// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"e64ed0a3","453":"76e310ac"}[chunkId] + ".chunk.js";
};